import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectChangesToYourJourneySCTIStep, makeSelectChangesToYourJourneySCTIStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';
import { appConfig } from '../../../configureApp';
import { SCTI_VISITING_NEW_ZEALAND_POLICY_TYPES } from '../constants/policyTypes';
import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormBeforeLeaving,
  resetFormAfterLeaving,
  resetFormSpecialEvent,
  resetFormRelevantPerson,
  resetFormTheTravelAgent,
  resetFormSpecialEventAL,
  resetFormRelevantPersonAL,
  resetFormRelevantPersonExistingHealthConditionAL,
  resetFormCuttingYourTrip,
  resetFormTravelInterruption,
  resetFormResumingYourTripBackOverseas,
  resetFormTheRelevantPersonsExistingHealthCondition,
  resetFormWereAnyOfYourTravelPlansOrganisedByATravelAgentPI,
  resetFormWereYouChargedACancellationFeeByTheTravelAgentPI,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import CurrencySelector from '../components/CurrencySelector';
import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation/';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import { stepChangesToYourJourneyLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { AdditionalList } from './components/Additional';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled, makeSelectPolicyTypeCode } from '../../App/selectors';
import FNOLTooltip from '../../../components/FNOLTooltip';
import Asterisk from '../../../components/Asterisk';

export class ChangesToYourJourneySCTIStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onPrescriptionMedicinesNotInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesNotInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onPrescriptionMedicinesForInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesForInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  onchangesToYourJourneyBeforeLeavingExpenseItems1 = (data) => {
    this.props.onFormDataChange('form.changesToYourJourneyBeforeLeavingExpenseItems1', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onchangesToYourJourneyBeforeLeavingExpenseItems2 = (data) => {
    this.props.onFormDataChange('form.changesToYourJourneyBeforeLeavingExpenseItems2', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onchangesToYourJourneyBeforeLeavingExpenseItems3 = (data) => {
    this.props.onFormDataChange('form.changesToYourJourneyBeforeLeavingExpenseItems3', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onchangesToYourJourneyBeforeLeavingExpenseItems4 = (data) => {
    this.props.onFormDataChange('form.changesToYourJourneyBeforeLeavingExpenseItems4', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onchangesToYourJourneyAfterLeavingExpenseItems1 = (data) => {
    this.props.onFormDataChange('form.changesToYourJourneyAfterLeavingExpenseItems1', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onchangesToYourJourneyAfterLeavingExpenseItems2 = (data) => {
    this.props.onFormDataChange('form.changesToYourJourneyAfterLeavingExpenseItems2', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onchangesCuttingYourTripShortToReturnHomeExpenseItems = (data) => {
    this.props.onFormDataChange('form.cuttingYourTripShortToReturnHomeExpenseItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onchangesResumingYourTripBackOverseasExpenseItems = (data) => {
    this.props.onFormDataChange('form.resumingYourTripBackOverseasItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onchangesTravelInterruptionExpenseItems = (data) => {
    this.props.onFormDataChange('form.travelInterruptionExpenseItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onchangesPetBoardingFacilityExpenseItems = (data) => {
    this.props.onFormDataChange('form.petBoardingFacilityExpenseItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onchangesChildCareExpensesExpenseItems = (data) => {
    this.props.onFormDataChange('form.childCareExpensesExpenseItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  handleExpensesSelected = (propertyName) => (event) => {
    const { whatExpensesAreYouClaimingFor } = this.props.form;
    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      if (name === 'Cutting your trip short to return home') {
        this.props.onResetFormCuttingYourTrip();
      }
      if (name === 'Travel Interruption') {
        this.props.onResetFormTravelInterruption();
      }
      if (name === 'Resuming your trip back overseas') {
        this.props.onResetFormResumingYourTripBackOverseas();
      }
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleTravelDisruptionExpensesSelected = (propertyName) => (event) => {
    const { didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption } = this.props.form;
    const expensesSelected = !!didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption && typeof didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS === 'function'
      ? didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS()
      : didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const {
      changesToYourJourneyAfterLeavingExpenseItems1 = [],
      changesToYourJourneyAfterLeavingExpenseItems2 = [],
      changesToYourJourneyBeforeLeavingExpenseItems1 = [],
      changesToYourJourneyBeforeLeavingExpenseItems2 = [],
      changesToYourJourneyBeforeLeavingExpenseItems3 = [],
      changesToYourJourneyBeforeLeavingExpenseItems4 = [],
      childCareExpensesExpenseItems = [],
      cuttingYourTripShortToReturnHomeExpenseItems = [],
      petBoardingFacilityExpenseItems = [],
      travelInterruptionExpenseItems = [],
      whatExpensesAreYouClaimingFor = [],
      resumingYourTripBackOverseasItems = [],
    } = this.props.form;


    const isHasAnyExpenses =
      changesToYourJourneyAfterLeavingExpenseItems1.length > 0 ||
      changesToYourJourneyAfterLeavingExpenseItems2.length > 0 ||
      changesToYourJourneyBeforeLeavingExpenseItems1.length > 0 ||
      changesToYourJourneyBeforeLeavingExpenseItems2.length > 0 ||
      changesToYourJourneyBeforeLeavingExpenseItems3.length > 0 ||
      changesToYourJourneyBeforeLeavingExpenseItems4.length > 0 ||
      childCareExpensesExpenseItems.length > 0 ||
      cuttingYourTripShortToReturnHomeExpenseItems.length > 0 ||
      petBoardingFacilityExpenseItems.length > 0 ||
      travelInterruptionExpenseItems.length > 0 ||
      whatExpensesAreYouClaimingFor.length > 0 ||
      resumingYourTripBackOverseasItems.length > 0

    const valid = isHasAnyExpenses && this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    if (propertyName === 'form.haveYouCanceledOrChangedYourJourneyBeforeLeaving') {
      this.props.onResetFormBeforeLeaving();
    }
    if (propertyName === 'form.wereYouDelayedWhileTravelingToASpecialEvent') {
      this.props.onResetFormSpecialEvent();
    }
    if (propertyName === 'form.didYouCancelOrChangeYourTravelPlansDueToARelevantPerson') {
      this.props.onResetFormRelevantPerson();
    }
    if (propertyName === 'form.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition') {
      this.props.onResetFormTheRelevantPersonsExistingHealthCondition();
    }
    if (propertyName === 'form.wereAnyOfYourTravelPlansOrganisedByATravelAgent') {
      this.props.onResetFormTheTravelAgent();
    }
    if (propertyName === 'form.haveYouChangedYourJourneyAfterLeaving') {
      this.props.onResetFormAfterLeaving();
    }
    if (propertyName === 'form.wereYouDelayedWhileTravelingToASpecialEventAL') {
      this.props.onResetFormSpecialEventAL();
    }
    if (propertyName === 'form.didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL') {
      this.props.onResetFormRelevantPersonAL();
    }
    if (propertyName === 'form.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL') {
      this.props.onResetFormRelevantPersonExistingHealthConditionAL();
    }
  };

  handleChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^\d*(\.\d{0,2})?$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value)) {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    const {
      changesToYourJourneyAfterLeavingExpenseItems1 = [],
      changesToYourJourneyAfterLeavingExpenseItems2 = [],
      changesToYourJourneyBeforeLeavingExpenseItems1 = [],
      changesToYourJourneyBeforeLeavingExpenseItems2 = [],
      changesToYourJourneyBeforeLeavingExpenseItems3 = [],
      changesToYourJourneyBeforeLeavingExpenseItems4 = [],
      childCareExpensesExpenseItems = [],
      cuttingYourTripShortToReturnHomeExpenseItems = [],
      petBoardingFacilityExpenseItems = [],
      travelInterruptionExpenseItems = [],
      whatExpensesAreYouClaimingFor = [],
      resumingYourTripBackOverseasItems = [],
    } = this.props.form;


    const isHasAnyExpenses =
      changesToYourJourneyAfterLeavingExpenseItems1.length > 0 ||
      changesToYourJourneyAfterLeavingExpenseItems2.length > 0 ||
      changesToYourJourneyBeforeLeavingExpenseItems1.length > 0 ||
      changesToYourJourneyBeforeLeavingExpenseItems2.length > 0 ||
      changesToYourJourneyBeforeLeavingExpenseItems3.length > 0 ||
      changesToYourJourneyBeforeLeavingExpenseItems4.length > 0 ||
      childCareExpensesExpenseItems.length > 0 ||
      cuttingYourTripShortToReturnHomeExpenseItems.length > 0 ||
      petBoardingFacilityExpenseItems.length > 0 ||
      travelInterruptionExpenseItems.length > 0 ||
      whatExpensesAreYouClaimingFor.length > 0 ||
      resumingYourTripBackOverseasItems.length > 0


    // const errors = this.validatorGroup.getErrors();
    const valid = isHasAnyExpenses && this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }

  renderChangesToYourJourneyBeforeLeavingExpenseItems1() {
    const { changesToYourJourneyBeforeLeavingExpenseItems1 = [] } = this.props.form;
    const newExpenseItems = this.appendIds(changesToYourJourneyBeforeLeavingExpenseItems1);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesToYourJourneyBeforeLeavingExpenseItems1}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderChangesToYourJourneyBeforeLeavingExpenseItems2() {
    const { changesToYourJourneyBeforeLeavingExpenseItems2 = [] } = this.props.form;
    const newExpenseItems = this.appendIds(changesToYourJourneyBeforeLeavingExpenseItems2);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesToYourJourneyBeforeLeavingExpenseItems2}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderChangesToYourJourneyBeforeLeavingExpenseItems3() {
    const { changesToYourJourneyBeforeLeavingExpenseItems3 = [] } = this.props.form;
    const newExpenseItems = this.appendIds(changesToYourJourneyBeforeLeavingExpenseItems3);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesToYourJourneyBeforeLeavingExpenseItems3}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderChangesToYourJourneyBeforeLeavingExpenseItems4() {
    const { changesToYourJourneyBeforeLeavingExpenseItems4 = [] } = this.props.form;
    const newExpenseItems = this.appendIds(changesToYourJourneyBeforeLeavingExpenseItems4);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesToYourJourneyBeforeLeavingExpenseItems4}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderChangesToYourJourneyAfterLeavingExpenseItems1() {
    const { changesToYourJourneyAfterLeavingExpenseItems1 = [] } = this.props.form;
    const newExpenseItems = this.appendIds(changesToYourJourneyAfterLeavingExpenseItems1);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesToYourJourneyAfterLeavingExpenseItems1}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderChangesToYourJourneyAfterLeavingExpenseItems2() {
    const { changesToYourJourneyAfterLeavingExpenseItems2 = [] } = this.props.form;
    const newExpenseItems = this.appendIds(changesToYourJourneyAfterLeavingExpenseItems2);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesToYourJourneyAfterLeavingExpenseItems2}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderCuttingYourTripShortToReturnHomeExpenseItems() {
    const { cuttingYourTripShortToReturnHomeExpenseItems = [] } = this.props.form;
    const newExpenseItems = this.appendIds(cuttingYourTripShortToReturnHomeExpenseItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesCuttingYourTripShortToReturnHomeExpenseItems}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderResumingYourTripBackOverseasItems() {
    const { resumingYourTripBackOverseasItems = [] } = this.props.form;
    const newExpenseItems = this.appendIds(resumingYourTripBackOverseasItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesResumingYourTripBackOverseasExpenseItems}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderTravelInterruptionExpenseItems() {
    const { travelInterruptionExpenseItems = [] } = this.props.form;
    const newExpenseItems = this.appendIds(travelInterruptionExpenseItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesTravelInterruptionExpenseItems}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderPetBoardingFacilityExpenseItems() {
    const { petBoardingFacilityExpenseItems = [] } = this.props.form;
    const newExpenseItems = this.appendIds(petBoardingFacilityExpenseItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesPetBoardingFacilityExpenseItems}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderChildCareExpensesExpenseItems() {
    const { childCareExpensesExpenseItems = [] } = this.props.form;
    const newExpenseItems = this.appendIds(childCareExpensesExpenseItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newExpenseItems}
          onChange={this.onchangesChildCareExpensesExpenseItems}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderTravelInterruption(isWorkingOverseas, isImmediateFamily) {
    const {
      didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    const expensesSelected = !!didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption && typeof didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS === 'function'
      ? didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS()
      : didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption || [];
    return (
      <div>
        {this.renderTravelInterruptionExpenseItems()}
        {(!isWorkingOverseas && !isImmediateFamily) && (
          <div className={'ml-4 row'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption} />
            </PageSectionHeader>
            <div className={'col-sm-12 form-group'}>
              <input
                disabled={isReadOnly}
                type="checkbox"
                name="Pet boarding facility"
                checked={expensesSelected.includes('Pet boarding facility')}
                onChange={this.handleTravelDisruptionExpensesSelected('form.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption')}
              />
              <span>
                <FormattedMessage {...messages.petBoardingFacility} />
              </span>
              {expensesSelected.includes('Pet boarding facility') && (
                <div className="col-sm-12 form-group">
                  {this.renderPetBoardingFacility()}
                </div>
              )}
            </div>
            <div className={'col-sm-12 form-group'}>
              <input
                disabled={isReadOnly}
                type="checkbox"
                name="Childcare expenses"
                checked={expensesSelected.includes('Childcare expenses')}
                onChange={this.handleTravelDisruptionExpensesSelected('form.didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption')}
              />
              <span>
                <FormattedMessage {...messages.childcareExpenses} />
              </span>
              {expensesSelected.includes('Childcare expenses') && (
                <div className="col-sm-12 form-group">
                  {this.renderchildCareExpenses()}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderCuttingYourTripShortToReturnHome() {
    return (
      <div>
        {this.renderCuttingYourTripShortToReturnHomeExpenseItems()}
      </div>
    );
  }

  renderResumingYourTripBackOverseas() {
    return (
      <div>
        {this.renderResumingYourTripBackOverseasItems()}
      </div>
    );
  }

  renderPetBoardingFacility() {
    return (
      <div>
        {this.renderPetBoardingFacilityExpenseItems()}
      </div>
    );
  }

  renderchildCareExpenses() {
    return (
      <div>
        {this.renderChildCareExpensesExpenseItems()}
      </div>
    );
  }

  renderChangedYourJourneyBeforeLeaving() {
    const {
      haveYouCanceledOrChangedYourJourneyBeforeLeaving,
      wereYouDelayedWhileTravelingToASpecialEvent,
      didYouCancelOrChangeYourTravelPlansDueToARelevantPerson,
      wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition,
      nameOfRelevantPerson,
      dateOfBirthOfRelevantPerson,
      relationshipWithRelevantPerson,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, policyTypeCode } = this.props;
    // For AU and NZ cell captive
    const internationalComprehensivePT = ['INT-COMP-AU', 'INT-COMP-NZ'];
    const isInternationalComprehensive = internationalComprehensivePT.includes(policyTypeCode);

    const domesticPT = ['DOM-AU', 'DOM-NZ'];
    const isDomestic = domesticPT.includes(policyTypeCode);

    const policyTypeWorkingOverseas = ['WORK-AU', 'WORK-NZ'];
    const isWorkingOverseas = policyTypeWorkingOverseas.includes(policyTypeCode);

    const policyTypeVisitingNZ = ['VISIT-NZ'];
    const isVisitingNewZealand = policyTypeVisitingNZ.includes(policyTypeCode);

    const policyTypeVISITPI = ['VISIT-NZ-WLP001'];
    const isVisitPartnerInsurance = policyTypeVISITPI.includes(policyTypeCode);

    const isInternationalStudent = policyTypeCode === 'INT-ST-NZ';
    const isImmediateFamily = isVisitingNewZealand || isInternationalStudent || isVisitPartnerInsurance;

    const policyTypePartnerInsurance = ['INT-COMP-WLP001', 'DOM-WLP001'];
    const isPartnerInsurance = policyTypePartnerInsurance.includes(policyTypeCode);

    const isAUAndNZCellCaptive = isInternationalComprehensive || isDomestic || isWorkingOverseas || isImmediateFamily;

    const isReadOnly = submitted || isSummary;
    return (
      <div>
        {(haveYouCanceledOrChangedYourJourneyBeforeLeaving === 'true' && !isInternationalStudent) &&
          <div className={'ml-2 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.wereYouDelayedWhileTravelingToASpecialEvent} />
                <FNOLTooltip dataFor={'wereYouDelayedWhileTravelingToASpecialEventbHint'}
                  content={messages.wereYouDelayedWhileTravelingToASpecialEventTooltip.defaultMessage} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wereYouDelayedWhileTravelingToASpecialEvent === 'true'}
                    onChange={this.handleChange('form.wereYouDelayedWhileTravelingToASpecialEvent')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wereYouDelayedWhileTravelingToASpecialEvent === 'false'}
                    onChange={this.handleChange('form.wereYouDelayedWhileTravelingToASpecialEvent')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {wereYouDelayedWhileTravelingToASpecialEvent === 'true' &&
          <div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.delayedJourneyToSpecialEvent} />
                </PageSectionHeader>
              </div>
            </div>
            {this.renderChangesToYourJourneyBeforeLeavingExpenseItems1()}
          </div>
        }
        {(wereYouDelayedWhileTravelingToASpecialEvent === 'false' || isInternationalStudent) &&
          <div className={'ml-3 row'}>
            <div className={'col-sm-12 form-group'}>
              {isImmediateFamily ? (
                <PageSectionHeader>
                  <FormattedMessage {...messages.didYouCancelOrChangeYourTravelPlansDueToAnImmediateFamilyMember} />
                  <FNOLTooltip dataFor={'didYouCancelOrChangeYourTravelPlansDueToAnImmediateFamilyMemberHint'} place={'bottom'}
                    content={messages.didYouCancelOrChangeYourTravelPlansDueToAnImmediateFamilyMemberTooltip.defaultMessage} />
                </PageSectionHeader>
              ) : (
                <PageSectionHeader>
                  <FormattedMessage {...messages.didYouCancelOrChangeYourTravelPlansDueToARelevantPerson} />
                  <FNOLTooltip dataFor={'cancelOrChangeTravelRelevantPersonHint'} place={'bottom'}
                    content={messages.didYouCancelOrChangeYourTravelPlansDueToARelevantPersonTooltip.defaultMessage} />
                </PageSectionHeader>
              )}
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didYouCancelOrChangeYourTravelPlansDueToARelevantPerson === 'true'}
                    onChange={this.handleChange('form.didYouCancelOrChangeYourTravelPlansDueToARelevantPerson')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didYouCancelOrChangeYourTravelPlansDueToARelevantPerson === 'false'}
                    onChange={this.handleChange('form.didYouCancelOrChangeYourTravelPlansDueToARelevantPerson')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {didYouCancelOrChangeYourTravelPlansDueToARelevantPerson === 'true' &&
          <div className={'ml-4 row'}>
            <div className={'col-sm-12 form-group'}>
              {isImmediateFamily ? (
                <PageSectionHeader>
                  <FormattedMessage {...messages.wasTheUnexpectedEventRelatedToTheImmediateFamilyMembersExistingHealthCondition} />
                  <FNOLTooltip dataFor={'wasTheUnexpectedEventRelatedToTheImmediateFamilyMembersExistingHealthConditionHint'}
                    place={'left'}
                    content={messages.wasTheUnexpectedEventRelatedToTheImmediateFamilyMembersExistingHealthConditionTooltip.defaultMessage} />
                </PageSectionHeader>
              ) : (
                <PageSectionHeader>
                  <FormattedMessage {...messages.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition} />
                  <FNOLTooltip dataFor={'wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionHint'}
                    place={'left'}
                    content={messages.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionTooltip.defaultMessage} />
                </PageSectionHeader>
              )}
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition === 'true'}
                    onChange={this.handleChange('form.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition === 'false'}
                    onChange={this.handleChange('form.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {didYouCancelOrChangeYourTravelPlansDueToARelevantPerson === 'false' &&
          <div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.cancellingOrChangingYourJourneyBeforeYouLeave} />
                </PageSectionHeader>
              </div>
            </div>
            {this.renderChangesToYourJourneyBeforeLeavingExpenseItems2()}
          </div>
        }


        {(wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition === 'true') &&
          <div className={'ml-4'}>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  {isImmediateFamily ? (
                    <FormattedMessage {...messages.nameOfImmediateFamilyMember} />
                  ) : (
                    <FormattedMessage {...messages.nameOfRelevantPerson} />
                  )}
                </PageSectionHeader>
                <Textbox
                  name="nameOfRelevantPerson"
                  type="text"
                  onChange={this.handleChange('form.nameOfRelevantPerson')}
                  value={nameOfRelevantPerson}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  {isImmediateFamily ? (
                    <FormattedMessage {...messages.dateOfBirthOfImmediateFamilyMember} />
                  ) : (
                    <FormattedMessage {...messages.dateOfBirthOfRelevantPerson} />
                  )}
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateOfBirthOfRelevantPerson"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateOfBirthOfRelevantPerson')}
                  value={dateOfBirthOfRelevantPerson}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  {isImmediateFamily ? (
                    <FormattedMessage {...messages.relationshipWithImmediateFamilyMember} />
                  ) : (
                    <FormattedMessage {...messages.relationshipWithRelevantPerson} />
                  )}
                </PageSectionHeader>
                <Textbox
                  name="relationshipWithRelevantPerson"
                  type="text"
                  onChange={this.handleChange('form.relationshipWithRelevantPerson')}
                  value={relationshipWithRelevantPerson}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  {isImmediateFamily ? (
                    <FormattedMessage {...messages.existingConditionOfAnImmediateFamilyMember} />
                  ) : (
                    <FormattedMessage {...messages.existingConditionOfARelevantPerson} />
                  )}
                </PageSectionHeader>
              </div>
            </div>
            {this.renderChangesToYourJourneyBeforeLeavingExpenseItems3()}
          </div>
        }
        {(wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition === 'false') &&
          <div className={'ml-4'}>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.cancellingOrChangingYourJourneyBeforeYouLeave} />
                </PageSectionHeader>
              </div>
            </div>
            {this.renderChangesToYourJourneyBeforeLeavingExpenseItems3()}
          </div>
        }
        {/* {(wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition === 'false' && (isPartnerInsurance || isVisitPartnerInsurance)) &&
          <div className={'ml-2 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.wereAnyOfYourTravelPlansOrganisedByATravelAgent} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wereAnyOfYourTravelPlansOrganisedByATravelAgentPI === 'true'}
                    onChange={this.handleChange('form.wereAnyOfYourTravelPlansOrganisedByATravelAgentPI')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wereAnyOfYourTravelPlansOrganisedByATravelAgentPI === 'false'}
                    onChange={this.handleChange('form.wereAnyOfYourTravelPlansOrganisedByATravelAgentPI')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        } */}
        {/* {(wereAnyOfYourTravelPlansOrganisedByATravelAgentPI === 'true') &&
          <div className={'ml-3 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.wereYouChargedACancellationFeeByTheTravelAgent} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wereYouChargedACancellationFeeByTheTravelAgentPI === 'true'}
                    onChange={this.handleChange('form.wereYouChargedACancellationFeeByTheTravelAgentPI')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wereYouChargedACancellationFeeByTheTravelAgentPI === 'false'}
                    onChange={this.handleChange('form.wereYouChargedACancellationFeeByTheTravelAgentPI')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {(wereYouChargedACancellationFeeByTheTravelAgentPI === 'true') &&
          <div className={'ml-4'}>
          <div className={'row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelAgentCancellationCover} />
              </PageSectionHeader>
            </div>
          </div>
          {this.renderChangesToYourJourneyBeforeLeavingExpenseItems4PI()}
        </div>
        } */}
      </div>
    );
  }

  renderChangedYourJourneyAfterLeaving() {
    const {
      haveYouChangedYourJourneyAfterLeaving,
      wereYouDelayedWhileTravelingToASpecialEventAL,
      didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL,
      wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL,
      nameOfRelevantPersonAL,
      dateOfBirthOfRelevantPersonAL,
      relationshipWithRelevantPersonAL,
      whatExpensesAreYouClaimingFor,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, policyTypeCode } = this.props;
    const isReadOnly = submitted || isSummary;

    const isVisitingNewZealand = SCTI_VISITING_NEW_ZEALAND_POLICY_TYPES.includes(policyTypeCode);

    const isInternationalStudent = policyTypeCode === 'INT-ST-NZ';

    const policyTypeWorkingOverseas = ['WORK-AU', 'WORK-NZ'];
    const isWorkingOverseas = policyTypeWorkingOverseas.includes(policyTypeCode);
    const isImmediateFamily = isVisitingNewZealand || isInternationalStudent;

    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    return (
      <div>
        {(haveYouChangedYourJourneyAfterLeaving === 'true' && !isInternationalStudent) &&
          <div className={'ml-2 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.wereYouDelayedWhileTravelingToASpecialEvent} />
                <FNOLTooltip dataFor={'wereYouDelayedWhileTravelingToASpecialEventALHint'}
                  content={messages.wereYouDelayedWhileTravelingToASpecialEventTooltip.defaultMessage} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wereYouDelayedWhileTravelingToASpecialEventAL === 'true'}
                    onChange={this.handleChange('form.wereYouDelayedWhileTravelingToASpecialEventAL')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wereYouDelayedWhileTravelingToASpecialEventAL === 'false'}
                    onChange={this.handleChange('form.wereYouDelayedWhileTravelingToASpecialEventAL')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {wereYouDelayedWhileTravelingToASpecialEventAL === 'true' &&
          <div className={'ml-4'}>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.delayedJourneyToSpecialEvent} />
                </PageSectionHeader>
              </div>
            </div>
            {this.renderChangesToYourJourneyAfterLeavingExpenseItems1()}
          </div>
        }
        {(wereYouDelayedWhileTravelingToASpecialEventAL === 'false' || isInternationalStudent) &&
          <div className={'ml-3 row'}>
            <div className={'col-sm-12 form-group'}>
              {isImmediateFamily ? (
                <PageSectionHeader>
                  <FormattedMessage {...messages.didYouCancelOrChangeYourTravelPlansDueToAnImmediateFamilyMember} />
                  <FNOLTooltip dataFor={'didYouCancelOrChangeYourTravelPlansDueToAnImmediateFamilyMemberALHint'}
                    content={messages.didYouCancelOrChangeYourTravelPlansDueToAnImmediateFamilyMemberTooltip.defaultMessage} />
                </PageSectionHeader>
              ) : (
                <PageSectionHeader>
                  <FormattedMessage {...messages.didYouCancelOrChangeYourTravelPlansDueToARelevantPerson} />
                  <FNOLTooltip dataFor={'didYouCancelOrChangeYourTravelPlansDueToARelevantPersonALHint'}
                    content={messages.didYouCancelOrChangeYourTravelPlansDueToARelevantPersonTooltip.defaultMessage} />
                </PageSectionHeader>
              )}
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL === 'true'}
                    onChange={this.handleChange('form.didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL === 'false'}
                    onChange={this.handleChange('form.didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL === 'true' &&
          <div className={'ml-4 row'}>
            <div className={'col-sm-12 form-group'}>
              {isImmediateFamily ? (
                <PageSectionHeader>
                  <FormattedMessage {...messages.wasTheUnexpectedEventRelatedToTheImmediateFamilyMembersExistingHealthCondition} />
                  <FNOLTooltip dataFor={'wasTheUnexpectedEventRelatedToTheImmediateFamilyMembersExistingHealthConditionALHint'}
                    place={'left'}
                    content={messages.wasTheUnexpectedEventRelatedToTheImmediateFamilyMembersExistingHealthConditionTooltip.defaultMessage} />
                </PageSectionHeader>
              ) : (
                <PageSectionHeader>
                  <FormattedMessage {...messages.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition} />
                  <FNOLTooltip dataFor={'wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionALHint'}
                    place={'left'}
                    content={messages.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionTooltip.defaultMessage} />
                </PageSectionHeader>
              )}
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL === 'true'}
                    onChange={this.handleChange('form.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL === 'false'}
                    onChange={this.handleChange('form.wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {(wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL === 'true') &&
          <div className={'ml-4'}>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  {isImmediateFamily ? (
                    <FormattedMessage {...messages.nameOfImmediateFamilyMember} />
                  ) : (
                    <FormattedMessage {...messages.nameOfRelevantPerson} />
                  )}
                </PageSectionHeader>
                <Textbox
                  name="nameOfRelevantPerson"
                  type="text"
                  onChange={this.handleChange('form.nameOfRelevantPersonAL')}
                  value={nameOfRelevantPersonAL}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  {isImmediateFamily ? (
                    <FormattedMessage {...messages.dateOfBirthOfImmediateFamilyMember} />
                  ) : (
                    <FormattedMessage {...messages.dateOfBirthOfRelevantPerson} />
                  )}
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateOfBirthOfRelevantPerson"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateOfBirthOfRelevantPersonAL')}
                  value={dateOfBirthOfRelevantPersonAL}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  {isImmediateFamily ? (
                    <FormattedMessage {...messages.relationshipWithImmediateFamilyMember} />
                  ) : (
                    <FormattedMessage {...messages.relationshipWithRelevantPerson} />
                  )}
                </PageSectionHeader>
                <Textbox
                  name="relationshipWithRelevantPerson"
                  type="text"
                  onChange={this.handleChange('form.relationshipWithRelevantPersonAL')}
                  value={relationshipWithRelevantPersonAL}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  {isImmediateFamily ? (
                    <FormattedMessage {...messages.existingConditionOfAnImmediateFamilyMember} />
                  ) : (
                    <FormattedMessage {...messages.existingConditionOfARelevantPerson} />
                  )}
                </PageSectionHeader>
              </div>
            </div>
            {this.renderChangesToYourJourneyAfterLeavingExpenseItems2()}
          </div>
        }
        {(wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL === 'false') &&
          <div className={'ml-4 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.whatExpensesAreYouClaimingFor} />
              </PageSectionHeader>
            </div>
            <div className={'col-sm-12 form-group'}>
              <div className="col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Cutting your trip short to return home"
                  checked={expensesSelected.includes('Cutting your trip short to return home')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.cuttingYourTripShortToReturnHome} />
                </span>
                {expensesSelected.includes('Cutting your trip short to return home') && (
                  <div className="col-sm-12 form-group">
                    {this.renderCuttingYourTripShortToReturnHome()}
                  </div>
                )}
              </div>
              <div className={'col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Travel Interruption"
                  checked={expensesSelected.includes('Travel Interruption')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.travelInterruption} />
                </span>
                {expensesSelected.includes('Travel Interruption') && (
                  <span>
                    <div className={'col-sm-12 form-group'}>
                      {this.renderTravelInterruption(isWorkingOverseas, isImmediateFamily)}
                    </div>
                  </span>
                )}
              </div>
              {(isWorkingOverseas || isInternationalStudent) && (
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Resuming your trip back overseas"
                    checked={expensesSelected.includes('Resuming your trip back overseas')}
                    onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                  />
                  <span>
                    {isInternationalStudent ? (
                      <FormattedMessage {...messages.resumptionOfJourneyBackToNZ} />
                    ) : (
                      <FormattedMessage {...messages.resumingYourTripBackOverseas} />
                    )}
                  </span>
                  {expensesSelected.includes('Resuming your trip back overseas') && (
                    <span>
                      <div className={'col-sm-12 form-group'}>
                        {this.renderResumingYourTripBackOverseas()}
                      </div>
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        }
        {didYouCancelOrChangeYourTravelPlansDueToARelevantPersonAL === 'false' &&
          <div className={'ml-4 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.whatExpensesAreYouClaimingFor} />
              </PageSectionHeader>
            </div>
            <div className={'col-sm-12 form-group'}>
              <div className="col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Cutting your trip short to return home"
                  checked={expensesSelected.includes('Cutting your trip short to return home')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.cuttingYourTripShortToReturnHome} />
                </span>
                {expensesSelected.includes('Cutting your trip short to return home') && (
                  <div className="col-sm-12 form-group">
                    {this.renderCuttingYourTripShortToReturnHome()}
                  </div>
                )}
              </div>
              <div className={'col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Travel Interruption"
                  checked={expensesSelected.includes('Travel Interruption')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.travelInterruption} />
                </span>
                {expensesSelected.includes('Travel Interruption') && (
                  <span>
                    <div className={'col-sm-12 form-group'}>
                      {this.renderTravelInterruption(isWorkingOverseas, isImmediateFamily)}
                    </div>
                  </span>
                )}
              </div>
              {(isWorkingOverseas || isInternationalStudent) && (
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Resuming your trip back overseas"
                    checked={expensesSelected.includes('Resuming your trip back overseas')}
                    onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                  />
                  <span>
                    {isInternationalStudent ? (
                      <FormattedMessage {...messages.resumptionOfJourneyBackToNZ} />
                    ) : (
                      <FormattedMessage {...messages.resumingYourTripBackOverseas} />
                    )}
                  </span>
                  {expensesSelected.includes('Resuming your trip back overseas') && (
                    <span>
                      <div className={'col-sm-12 form-group'}>
                        {this.renderResumingYourTripBackOverseas()}
                      </div>
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        }
      </div>
    );
  }

  render() {
    const {
      haveYouCanceledOrChangedYourJourneyBeforeLeaving,
      haveYouChangedYourJourneyAfterLeaving,
      wereYouChargedACancellationFeeByTheTravelAgent
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading, intl, policyTypeCode } = this.props;
    const isVHIPolicy = policyTypeCode === 'VHI';

    const policyTypePartnerInsurance = ['INT-COMP-WLP001', 'DOM-WLP001', 'VISIT-NZ-WLP001'];
    const isPartnerInsurance = policyTypePartnerInsurance.includes(policyTypeCode);

    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        <div>
          <div className={'row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.thisSectionRelatesToTravelExpensesSuchAsFlights} />
              </PageSectionHeader>
            </div>
          </div>
          <div className={'ml-2 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.haveYouCanceledOrChangedYourJourneyBeforeLeaving} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={haveYouCanceledOrChangedYourJourneyBeforeLeaving === 'true'}
                    onChange={this.handleChange('form.haveYouCanceledOrChangedYourJourneyBeforeLeaving')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={haveYouCanceledOrChangedYourJourneyBeforeLeaving === 'false'}
                    onChange={this.handleChange('form.haveYouCanceledOrChangedYourJourneyBeforeLeaving')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
            {haveYouCanceledOrChangedYourJourneyBeforeLeaving === 'true' &&
              <div className="col-sm-12 form-group">
                {this.renderChangedYourJourneyBeforeLeaving()}
              </div>
            }

            {isPartnerInsurance && (
              <div>
                <div className={'col-sm-12 form-group'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.wereYouChargedACancellationFeeByTheTravelAgent} />
                  </PageSectionHeader>
                  <FlexBox>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="true"
                        checked={wereYouChargedACancellationFeeByTheTravelAgent === 'true'}
                        onChange={this.handleChange('form.wereYouChargedACancellationFeeByTheTravelAgent')}
                      />
                      <FormattedMessage {...messages.yes} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="false"
                        checked={wereYouChargedACancellationFeeByTheTravelAgent === 'false'}
                        onChange={this.handleChange('form.wereYouChargedACancellationFeeByTheTravelAgent')}
                      />
                      <FormattedMessage {...messages.no} />
                    </OptionsContainer>
                  </FlexBox>
                </div>
              </div>
            )}
            {((isPartnerInsurance && wereYouChargedACancellationFeeByTheTravelAgent) === 'true') &&
              <div className={'col-sm-12 form-group'}>
                <div className='ml-3'>
                  <PageSectionHeader>
                  <FormattedMessage {...messages.travelAgentCancellationCover} />
                  </PageSectionHeader>
                  {this.renderChangesToYourJourneyBeforeLeavingExpenseItems4()}
                </div>
              </div >
            }


            {!isVHIPolicy &&
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.haveYouChangedYourJourneyAfterLeaving} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={haveYouChangedYourJourneyAfterLeaving === 'true'}
                      onChange={this.handleChange('form.haveYouChangedYourJourneyAfterLeaving')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={haveYouChangedYourJourneyAfterLeaving === 'false'}
                      onChange={this.handleChange('form.haveYouChangedYourJourneyAfterLeaving')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            }
            {haveYouChangedYourJourneyAfterLeaving === 'true' &&
              <div className="col-sm-12 form-group">
                {this.renderChangedYourJourneyAfterLeaving()}
              </div>
            }
          </div>
        </div>
        {
          !isSummary && (
            <div className={'row justify-content-between'}>
              <div className={'col-12 col-sm-auto'}>
                <div className={'row'}>
                  <div className={'col-12 col-sm-auto'}>
                    <button
                      className={`${appConfig.reactAppEnv === 'scti' ? 'base-button back-button' : 'btn-outline'}`}
                      onClick={this.props.prev}
                      onKeyDown={this.handleKeyDown}
                    >
                      {intl.formatMessage({ id: 'fastCover.button.back' })}
                    </button>
                  </div>
                  <div className={'col-12 col-sm-auto'}>
                    <Button
                      onClick={this.handleNext}
                      onKeyDown={this.handleKeyDown}
                      innerRef={(ref) => {
                        this.nextButton = ref;
                      }}
                    >
                      {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
                    </Button>
                  </div>
                </div>
              </div>
              <div className={'col-12 col-sm-auto'}>
                {!submitted && (
                  <AsyncButton
                    id={this.saveButtonId}
                    className="btn-outline"
                    loading={loading}
                    spinner={this.showSpinnerForElement(this.saveButtonId)}
                    onClick={this.handleSaveButtonClick}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.save' })}
                  </AsyncButton>
                )}
              </div>
            </div>
          )
        }
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div >
    );
  }
}

ChangesToYourJourneySCTIStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormBeforeLeaving: PropTypes.func,
  onResetFormSpecialEvent: PropTypes.func,
  onResetFormRelevantPerson: PropTypes.func,
  onResetFormTheTravelAgent: PropTypes.func,
  onResetFormAfterLeaving: PropTypes.func,
  onResetFormSpecialEventAL: PropTypes.func,
  onResetFormRelevantPersonAL: PropTypes.func,
  onResetFormRelevantPersonExistingHealthConditionAL: PropTypes.func,
  onResetFormCuttingYourTrip: PropTypes.func,
  onResetFormTravelInterruption: PropTypes.func,
  onResetFormResumingYourTripBackOverseas: PropTypes.func,
  onResetFormTheRelevantPersonsExistingHealthCondition: PropTypes.func,
  onResetFormWereAnyOfYourTravelPlansOrganisedByATravelAgentPI: PropTypes.func,
  onResetFormWereYouChargedACancellationFeeByTheTravelAgentPI: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  intl: intlShape.isRequired,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  policyTypeCode: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectChangesToYourJourneySCTIStep(),
  errors: makeSelectChangesToYourJourneySCTIStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  policyTypeCode: makeSelectPolicyTypeCode(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormBeforeLeaving: () => dispatch(resetFormBeforeLeaving()),
  onResetFormSpecialEvent: () => dispatch(resetFormSpecialEvent()),
  onResetFormRelevantPerson: () => dispatch(resetFormRelevantPerson()),
  onResetFormTheTravelAgent: () => dispatch(resetFormTheTravelAgent()),
  onResetFormAfterLeaving: () => dispatch(resetFormAfterLeaving()),
  onResetFormSpecialEventAL: () => dispatch(resetFormSpecialEventAL()),
  onResetFormRelevantPersonAL: () => dispatch(resetFormRelevantPersonAL()),
  onResetFormRelevantPersonExistingHealthConditionAL: () => dispatch(resetFormRelevantPersonExistingHealthConditionAL()),
  onResetFormCuttingYourTrip: () => dispatch(resetFormCuttingYourTrip()),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormResumingYourTripBackOverseas: () => dispatch(resetFormResumingYourTripBackOverseas()),
  onResetFormTheRelevantPersonsExistingHealthCondition: () => dispatch(resetFormTheRelevantPersonsExistingHealthCondition()),
  onResetFormWereAnyOfYourTravelPlansOrganisedByATravelAgentPI: () => dispatch(resetFormWereAnyOfYourTravelPlansOrganisedByATravelAgentPI()),
  onResetFormWereYouChargedACancellationFeeByTheTravelAgentPI: () => dispatch(resetFormWereYouChargedACancellationFeeByTheTravelAgentPI()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'changesToYourJourneySCTIStep', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(ChangesToYourJourneySCTIStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.ChangesToYourJourney/index.js